import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { pairwise, startWith } from 'rxjs/operators';
import { PadAgreement } from '../../_models/models';
import { FormPartComponent } from '../form-part-component';

interface PadAgreementValue {
  paId: number | null;
  applyPaDiscount: boolean | null;
}

@Component({
  selector: 'app-pad-agreement-dropdown',
  templateUrl: './pad-agreement-dropdown.component.html',
  styleUrls: ['./pad-agreement-dropdown.component.less'],
  providers: FormPartComponent.createDirectiveProviders(forwardRef(() => PadAgreementDropdownComponent))
})
export class PadAgreementDropdownComponent extends FormPartComponent<PadAgreementValue, UntypedFormGroup> implements OnInit {
  @Input() padAgreements: PadAgreement[] = [];

  readonly form: UntypedFormGroup;

  constructor(
    private formBuilder: UntypedFormBuilder
  ) {
    super();
    this.form = this.formBuilder.group({
      paId: [null],
      applyPaDiscount: [null]
    });
  }

  protected get formPart(): UntypedFormGroup {
    return this.form;
  }

  protected getFormPartValidationErrors(): ValidationErrors {
    return this.form.errors || null;
  }

  ngOnInit(): void {
    this.setupPaIdValueChanges();
  }

  override writeValue(value: PadAgreementValue | null | undefined): void {
    const formValue = value || { paId: null, applyPaDiscount: null };
    this.form.patchValue(formValue, { emitEvent: false });
  }

  private setupPaIdValueChanges(): void {
    const subscription = this.form.get('paId').valueChanges
      .pipe(
        startWith(null),
        pairwise()
      )
      .subscribe(([prevPaId, currPaId]) => {
        this.updateApplyPaDiscount(prevPaId, currPaId);
      });
    this.subscriptions.add(subscription);
  }

  private updateApplyPaDiscount(prevPaId: number | null, currPaId: number | null): void {
    if (currPaId === null) {
      this.form.controls.applyPaDiscount.setValue(null, { emitEvent: false });
    } else if (prevPaId === null && this.form.controls.applyPaDiscount.value === null) {
      this.form.controls.applyPaDiscount.setValue(true, { emitEvent: false });
    }
  }

  isRadioDisabled(): boolean {
    const selectedPaId = this.getSelectedPaId();
    if (!selectedPaId) {
      return true;
    }

    const selectedPad = this.padAgreements.find(pa => pa.paId === selectedPaId);
    return this.isPadExpired(selectedPad);
  }

  private getSelectedPaId(): number | null {
    return this.form.get('paId')?.value ?? null;
  }

  isPadExpired(pad: PadAgreement | undefined): boolean {
    return pad?.isExpired === true;
  }

  isPadExpiredById(paId: number | null | undefined): boolean {
    if (paId === null || paId === undefined) {
      return false;
    }
    const pad = this.padAgreements.find(pa => pa.paId === paId);
    return this.isPadExpired(pad);
  }
}
